"use strict";

var _require = require("fastestsmallesttextencoderdecoder"),
    NodeTextDecoder = _require.TextDecoder;

module.exports = typeof TextDecoder === "undefined" ? NodeTextDecoder : TextDecoder;